import { displayPartnerCustomerList } from '../../../../widgets/partner-customer-widget';
import { getSelectedItem } from './select-items';
import { searchAvailList } from './search-list';

import GetCardGroups from '../../../../../routes/get-card-groups';

/**
 * Function that gets a list of card group data and displays it.
 * 
 * @retuns void
 */
const GetCardGroupData = async () => { 
  const { body } = await GetCardGroups();

  const mapList = Object.values(body).map((r: any) => ({
      id: r.cardGroupId,
      name: r.cardGroupName
  }));

  const customerList = document.querySelectorAll<HTMLElement>('[data-id]');
  const available = Array.from(customerList).map(e => ({
    customerId: e.getAttribute('data-id')
  }));

  const avalCustomers = mapList.filter(item => available.every(item2 => item2.customerId != item.id));
  const avaListContainer = document.querySelector('.aafp_list-result-container') as HTMLElement;
  const searchBar = document.querySelector('#aafp_customer-input') as HTMLInputElement;
  if (avaListContainer) {
    avaListContainer.innerText = '';
    displayPartnerCustomerList(avalCustomers, avaListContainer);

    const con = document.querySelector('.aafp_card-group-container') as HTMLElement;
    getSelectedItem(avaListContainer, con);
    searchAvailList(searchBar, avaListContainer);
  }
}

export default GetCardGroupData;